export default "__VITE_ASSET__BPR$E9g6__"